<template>
  <div>
    <div class="title">
      <h4 class="text-center text-success font-weight-bold py-3">
        Análise do Molde <i class="fas fa-sticky-note"></i>
      </h4>
    </div>
    <div class="contentModal">
      <div class="cardProcessPhoto">
        <div class="title">
          <h3>Abertura da Embalagem</h3>
          <i class="fa fa-dropbox"></i>
        </div>
        <AberturaEmbalagem
          v-if="configInputs == 0 || configInputs == 1"
          :configInputs="configInputs"
        />
        <AberturaEmbalagemEdit
          v-if="configInputs == undefined"
          :configInputs="configInputs"
        />
      </div>

      <div class="cardProcessPhoto">
        <div class="title">
          <h3>Fotos Molde Fechado</h3>
          <i class="fas fa-images"></i>
        </div>
        <MoldeFechado
          v-if="configInputs == 0 || configInputs == 1"
          :configInputs="configInputs"
        />
        <MoldeFechadoEdit v-if="configInputs == undefined" />
      </div>

      <div class="cardProcessPhoto">
        <div class="title">
          <h3>Fotos Molde Aberto</h3>
          <i class="fas fa-images"></i>
        </div>
        <MoldeAberto
          v-if="configInputs == 0 || configInputs == 1"
          :configInputs="configInputs"
        />
        <MoldeAbertoEdit
          v-if="configInputs == undefined"
          :configInputs="configInputs"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AberturaEmbalagem from "./Modules/Abertura_Embalagem.vue";
import AberturaEmbalagemEdit from "./ModulesEdit/Abertura_Embalagem.vue";
import MoldeFechado from "./Modules/Molde-Fechado.vue";
import MoldeFechadoEdit from "./ModulesEdit/Molde-Fechado.vue";
import MoldeAberto from "./Modules/Molde-Aberto.vue";
import MoldeAbertoEdit from "./ModulesEdit/Molde-Aberto.vue";

export default {
  components: {
    AberturaEmbalagem,
    MoldeAberto,
    MoldeFechado,
    AberturaEmbalagemEdit,
    MoldeAbertoEdit,
    MoldeFechadoEdit,
  },
  props: {
    configInputs: Number,
  },
  data() {
    return {
      teste: "",
      DataAllImages: {
        AberturaEmbalagem: Object,
        MoldeFechado: Object,
        MoldeAberto: Object,
      },
    };
  },
};
</script>

<style>
.contentModal {
  height: 100%;
  padding: 1rem 2rem;
  transition: 0.5s;
}

.contentModal .cardProcessPhoto {
  width: 100%;
  position: relative;
  padding: 0.5rem;
  background-color: var(--white);
  margin: 1rem 0;
  border-radius: 0.4rem;
}

.contentModal .cardProcessPhoto .title {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: var(--green);
  color: var(--white);
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
}

.flex-column {
  display: flex;
  align-items: center;
  list-style: none;
  justify-content: center;
}

.nav-pills .nav-link {
  border-radius: 0.35rem;
}

a {
  color: var(--green);
}

.active a {
  color: var(--white);
  background-color: var(--green);
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--white);
  background-color: var(--green);
}

.nav-pills .nav-link {
  border-radius: 0.35rem;
}

.text-success {
  color: var(--green) !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}
.text-center {
  text-align: center !important;
}
.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}
.pt-3,
.py-3 {
  padding-top: 1rem !important;
}
.h4,
h4 {
  font-size: 1.5rem;
}

@media (max-width: 425px) {
  .flex-column {
    flex-direction: column;
  }
  .contentModal .cardProcessPhoto .title {
    font-size: 1rem;
  }
}
</style>
